<ng-container *transloco="let t; prefix: scope">
  <ng-container *ngIf="isSwedishFirm$ | async as isSwedishFirm">
    <div>
      <bl-frontend-button [text]="t('addFinancialYear')" icon="plus-circle" (onclick)="toggleAddFinancialYear()">
      </bl-frontend-button>
    </div>
    <br *ngIf="showAddFinancialYear" />
    <div
      *ngIf="showAddFinancialYear"
      class="flex table-bordered p-3 justify-between"
      [ngClass]="{ 'w-1/2': !isSwedishFirm.value }">
      <div class="mr-3 flex flex-col justify-between">
        <p>{{ t('startDate') }}</p>
        <app-calendar
          [(selectedDate)]="financialYearModel.span.start"
          defaultDate=""
          appendTo="body"
          styleClass=""></app-calendar>
      </div>
      <div class="mr-3 flex flex-col justify-between">
        <p>{{ t('endDate') }}</p>
        <app-calendar
          [(selectedDate)]="financialYearModel.span.end"
          defaultDate=""
          appendTo="body"
          styleClass=""></app-calendar>
      </div>
      <ng-container *ngIf="isSwedishFirm.value">
        <div class="mr-3 flex flex-col justify-between">
          <p [innerHTML]="t('largeCompanyTitle') | safeHtml"></p>
          <p-checkbox [binary]="true" [(ngModel)]="financialYearModel.largeCompany"></p-checkbox>
        </div>
        <div class="mr-3 flex flex-col justify-between">
          <p [innerHTML]="t('euCommerceTitle') | safeHtml"></p>
          <p-checkbox [binary]="true" [(ngModel)]="financialYearModel.euCommerce"></p-checkbox>
        </div>
        <div class="mr-3 flex flex-col justify-between">
          <p [innerHTML]="t('electronicVatTitle') | safeHtml"></p>
          <p-checkbox [binary]="true" [(ngModel)]="financialYearModel.electronicVat"></p-checkbox>
        </div>
        <div class="mr-3 flex flex-col justify-between">
          <p [innerHTML]="t('electronicCompilationTitle') | safeHtml"></p>
          <p-checkbox [binary]="true" [(ngModel)]="financialYearModel.electronicCompilation"></p-checkbox>
        </div>
        <div class="mr-3 flex flex-col justify-between">
          <p [innerHTML]="t('firmTaxRespiteTitle') | safeHtml"></p>
          <p-checkbox
            [binary]="true"
            [(ngModel)]="financialYearModel.firmTaxRespite"
            (ngModelChange)="checkIfTaxRespiteIsPossible($event)"></p-checkbox>
        </div>
        <div class="mr-3 flex flex-col justify-between">
          <p [innerHTML]="t('electronicTaxTitle') | safeHtml"></p>
          <p-checkbox [binary]="true" [(ngModel)]="financialYearModel.electronicTax"></p-checkbox>
        </div>
      </ng-container>

      <div class="flex flex-col justify-end">
        <bl-frontend-button
          [text]="'shared.save' | transloco"
          (onclick)="saveFinancialYear()"
          [disabled]="client.archived || client.id === -1"></bl-frontend-button>
        <bl-frontend-button
          [text]="'shared.reset' | transloco"
          (onclick)="reset()"
          variant="secondary"
          class="mt-3"
          *ngIf="isSwedishFirm.value"></bl-frontend-button>
      </div>
    </div>
    <br />

    <div [ngClass]="{ 'w-1/2': !isSwedishFirm.value }">
      <app-table
        [columns]="columns$ | async"
        [data]="clientFinancialYears$ | async"
        [paginator]="false"
        [searchField]="false"
        [columnSelector]="false"
        (cellClick)="onRowSelect($event)"
        rowClass="cursor-pointer hover:underline"
        [customHeader]="columnHeaders$ | async"
        [useFixedStyle]="true">
        <ng-template tableTemplate="bodyCell" tableBodyCellField="span.formattedStart" let-fieldValue
          >{{ fieldValue }}
        </ng-template>
        <ng-template tableTemplate="bodyCell" tableBodyCellField="span.formattedEnd" let-fieldValue
          >{{ fieldValue }}
        </ng-template>
        <ng-template tableTemplate="bodyCell" tableBodyCellField="default" let-fieldValue let-financialYear="rowData">
          <span
            [style.display]="fieldValue ? 'block' : 'none'"
            class="fa fa-check"
            style="text-align: center; color: green">
          </span>
        </ng-template>
        <ng-template tableTemplate="bodyCell" tableBodyCellField="action" let-financialYear="rowData">
          <span
            *ngIf="!client.archived"
            (click)="deleteFinancialYear(financialYear.id)"
            class="far fa-trash-alt text-center">
          </span>
        </ng-template>
        <ng-template tableTemplate="emptyMessage">{{ t('noFinancialYearCreated') }}</ng-template>
      </app-table>
    </div>
  </ng-container>
</ng-container>
